import React from "react";
import QuickRFQ from "./QuickRFQ";

const FreeRFQCreate = (props) => {
  return <QuickRFQ {...props} mode="free" />;
};

export default FreeRFQCreate;
